export const formatPlainNumber = (
  val: number | string | null | undefined,
): string =>
  Number(val || 0).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

export const formatCurrency = (
  amount: number | null | undefined,
  currencyCode?: string,
): string => {
  const currency = (currencyCode ?? "KES").toUpperCase();

  try {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency,
    }).format(amount ?? 0);
  } catch {
    // Fallback for invalid or unsupported currency codes
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "KES",
    }).format(amount ?? 0);
  }
};

export const getErrorMessage = (error: unknown, fallback: string): string => {
  return error instanceof Error ? error.message : fallback;
};

export const formatIsoDateForInput = (isoString?: string): string => {
  if (!isoString) return "";

  return new Date(isoString).toISOString().slice(0, 10);
};
